import { useState, useEffect, useCallback } from 'react';
import { getAdminMe, adminLogout } from '../api/auth';
import type { AdminUser } from '../types';

interface AdminAuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  admin: AdminUser | null;
  logout: () => Promise<void>;
  refetch: () => Promise<void>;
}

export function useAdminAuth(): AdminAuthState {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [admin, setAdmin] = useState<AdminUser | null>(null);

  const fetchAdmin = useCallback(async () => {
    setIsLoading(true);
    try {
      const adminData = await getAdminMe();
      setAdmin(adminData);
      setIsAuthenticated(true);
    } catch {
      setAdmin(null);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAdmin();
  }, [fetchAdmin]);

  const logout = useCallback(async () => {
    try {
      await adminLogout();
    } finally {
      setAdmin(null);
      setIsAuthenticated(false);
      window.location.href = '/admin/login';
    }
  }, []);

  return {
    isAuthenticated,
    isLoading,
    admin,
    logout,
    refetch: fetchAdmin,
  };
}
